import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputAdornment, Typography, makeStyles } from '@material-ui/core';
import { NumberTextField } from '~/modules/common/components/NumberTextField/NumberTextField';

const MIN_TARGET_UTILIZATION = 0;
const MAX_TARGET_UTILIZATION = 200;

const useStyles = makeStyles(theme => ({
  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.25)
  },
  numberInput: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      height: theme.spacing(6.5)
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      MozAppearance: 'textfield'
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0
    }
  },
  suffixText: {
    flex: 1,
    color: theme.palette.text.secondary
  }
}));

const percentAdornment = (
  <InputAdornment position="end" disablePointerEvents>
    <Typography variant="body2" color="textSecondary">
      %
    </Typography>
  </InputAdornment>
);

const TargetUtilizationInput = ({ value, onChange }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const label = formatMessage({
    id: 'resourceManagementDashboard.targetUtilizationSettings.inputLabel'
  });

  return (
    <div className={classes.inputRow}>
      <NumberTextField
        autoFocus
        className={classes.numberInput}
        label={label}
        variant="outlined"
        value={value}
        onChange={onChange}
        min={MIN_TARGET_UTILIZATION}
        max={MAX_TARGET_UTILIZATION}
        endAdornment={percentAdornment}
      />
      <Typography variant="body2" className={classes.suffixText} noWrap>
        <FormattedMessage id="resourceManagementDashboard.targetUtilizationSettings.inputSuffix" />
      </Typography>
    </div>
  );
};

TargetUtilizationInput.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TargetUtilizationInput;
